angular.module('zc.projects')

.controller 'AddCouponsCtrl', ($scope, $filter, $state, $translate, $modal, Page, Campaign, Devise, currentProject, campaigns) ->
  Page.setBodyClass ''
  $translate('projectsCampaigns.addCouponsController.campaignList').then (translation) ->
    Page.setTitle translation

  $scope.Devise = Devise
  $scope.currentProject = currentProject

  filterActiveCampaigns = (campaigns) ->
    $scope.activeCampaigns = _.chain campaigns
      .filter (campaign) -> campaign.current_status in ['active','blocked']
      .filter (campaign) -> campaign.incentives.length > 0
      .value()
  filterActiveCampaigns(campaigns)

  $scope.openModal = (campaign) ->
    modalInstance = $modal.open
      templateUrl: '/templates/projects.campaigns/add_coupons_modal.html'
      controller: 'AddCouponsModalCtrl'
      resolve:
        campaign: -> campaign
        parentController: -> $scope

  $scope.refreshCampaign = ->
    Campaign.all {projectId: currentProject.id }
    .then (campaigns) ->
      filterActiveCampaigns(campaigns)

  $scope.removeIncentive = (campaign, id) ->
    campaign.incentive_ids = _.without(campaign.incentive_ids, id)
    Campaign.update({
      projectId: campaign.project_id
      campaignId: campaign.id
    }, campaign).then (res) ->
      $scope.refreshCampaign()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/add_coupons.controller.js.coffee